(function() {

    'use strict';
    angular.module('app')
        .controller('changePasswordController', ['$scope', '$location', '$routeParams', 'accountsService',changePasswordController]
            );

    function changePasswordController($scope, $location, $routeParams, accountsService) {
        $scope.model = {};

        $scope.continue = function() {
            $location.url('/dashboard');
        };

        $scope.submit = function() {
            $scope.model.submitted = true;
            if (!$scope.changePasswordForm.$valid) {
                return;
            }

            $scope.model.working = true;

            accountsService.changePassword($scope.model.currentPassword, $scope.model.password)
                .then(function(response) {
                    if (response.errors.length > 0) {
                        $scope.model.error = response.errors[0].message;
                    } else {
                        $scope.model.success = true;
                    }
                    $scope.model.complete = true;


                },
                    function(response) {
                        $scope.model.working = false;

                        $scope.model.error = response.errors[0].message;
                        $scope.model.complete = true;
                        $scope.model.success = false;
                    });
        };
    }
})();